<div [ngClass]="{'optional-styling' : optionalStyling, 'centered-styling' : centeredStyling}">
  <nav class="top-nav header-color" id="nav" role="navigation">
    <div class="menu-container">
      <ul class="exo-menu">
        @for (item of activeItems; track item; let i = $index) {
          <li (mouseover)="hideMenu = false" class="drop-down">
            <a [ngClass]="{'active-menu': headerMenu === item.Label.toLowerCase()}" class="root-menu pointer">
              <!--      <span class="material-icons">{{item.iconName}} </span>-->
              <span class="menu-label"> {{ item.Label }}</span>
            </a>
            @if (item.Items) {
              <div [ngClass]="{'closed' : hideMenu, 'report-menu-4' : (item.Label === 'Reporting' && i >= 4),  'report-menu-3' : (item.Label === 'Reporting' && i === 3)}"
                   class="drop-down-ul mega">
                <div class="mega-container">
                  @for (subItem of item.Items; track subItem) {
                    <ul class="mega-category">
                      <div class="mega-header"> {{ subItem.Label }}</div>
                      <!--                      <li>-->
                      <!--                        @if(item.Label === 'Support' && subItem.Label === 'Help' && !_hideContactSupport()) {-->
                      <!--                          <a (click)="openContanct()">-->
                      <!--                            <span class="fas fa-user-headset"></span>-->
                      <!--                            <span> Contact Support</span>-->
                      <!--                          </a>-->
                      <!--                        }-->
                      <!--                      </li>-->
                      @for (subSubItem of subItem.Items; track subSubItem) {
                        <li>
                          @if (!subSubItem.Disabled) {
                            <a (click)="goToUrl(subSubItem.Route)">
                              <span class="{{subSubItem.Icon}}"></span>
                              <span> {{ subSubItem.Label| labelReplace }}</span>
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  }
                </div>
              </div>
            }
          </li>
        }
      </ul>
    </div>
  </nav>
</div>
